module.exports = __webpack_public_path__ + "img/symbol_1.f161fa21.png";